import { MensajeService } from './../mensaje/mensaje.service';
import { Contenedor } from 'app/view/impo/impo';
import { ArvService } from './arv.service';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { OnChanges } from '@angular/core/src/metadata/lifecycle_hooks';
import { ARV } from 'app/modulo_compartido/arv/arv';

declare var $: any;

@Component({
    moduleId: module.id,
    selector: 'avr-detalle',
    templateUrl: './arv.component.html',
    styles: [`
        .naranja{
            color: #F87729;
            background-color: #FEEEE4;
            border-color: #F87729;
        }
        .receipt-head{
            background-color: #004165;
        }
        .btn.btn-circle{
            float: right;
        }

        .btn-circle {
            cursor:pointer;
            width: 35px;
            height: 35px;
            text-align: center;
            padding: 6px 0;
            line-height: 1.428571429;
            border-radius: 50px;
        }
    `]
})

export class ArvComponent implements OnChanges {

    @Input() cita: Contenedor;
    @Input() tipo: string;

    estado: string = "";

    @Output() close: EventEmitter<boolean> = new EventEmitter();

    data: Array<ARV>;

    constructor(private arv: ArvService, private sms: MensajeService) {
        this.cita = new Contenedor();
        this.data = new Array<ARV>();
    }

    cerrar_modal() {
        this.close.emit(false);
    }

    ngOnChanges() {
        if (this.tipo == "1") {
            this.estado = String(this.cita.codigoEstDetalle);
        } else if (this.tipo == "2") {
            this.estado = String(this.cita.codigoEstado);
        }

        if (this.cita.numeroCita != undefined && this.cita.numeroCita != 0) {
            this.data = new Array<ARV>();
            this.arv.get_arv(this.cita.numeroCita).subscribe(resp => {
                this.data = resp;
                for (var i in this.data) {
                    var notas = (new DOMParser()).parseFromString(this.data[i].notas, "text/xml").getElementsByTagName("Item");
                    var not = []
                    for (var e = 0; e < notas.length; e++) {
                        not.push({
                            nota: notas[e].innerHTML
                        })
                    }
                    this.data[i].notas = not;
                    //console.log(this.data[i].notas);
                }
                // console.log(this.data);
                $("#detalle-arv").modal("show");
            }, error => {
                this.sms.enviarAlerta({ mensaje: error, tipo: 2 })
            });
        }
    }


    printDiv(nombreDiv) {
        var contenido = document.getElementById(nombreDiv).innerHTML;
        var contenidoOriginal = document.body.innerHTML;

        document.body.innerHTML = contenido;

        print();

        document.body.innerHTML = contenidoOriginal;
    }

    imprimir(data) {
        var content = document.getElementById("imprimir").innerHTML;
        var style = document.querySelector("style");
        var mywindow = open('', 'Print', 'height=600,width=800');
        mywindow.document.write('<html><head><title>Impresion ARV</title>');
        mywindow.document.write('</head><body>');
        mywindow.document.write('<style>@media print {body {font-family: -apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;font-size: 1rem;font-weight: normal;line-height: 1.5;}#botones{ display:none !important;} #demares {font-size: 1.25rem !important;} .col-sm-8 {-ms-flex: 0 0 100% !important;flex: 0 0 100% !important;max-width: 100% !important;} .color-three {color: #FF6319 !important;} .mt-3 {margin-top: 1rem !important ;} .table-bordered {border: 1px solid #eceeef !important;} .row {display: flex !important;-ms-flex-wrap: wrap !important;flex-wrap: wrap !important;margin-right: -15px !important;margin-left: -15px !important;} .naranja{color: #F87729 !important;background-color: #FEEEE4 !important;border-color: #F87729 !important;} .naranja[_ngcontent-c4] {color: #F87729 !important; background-color: #FEEEE4  !important; border-color: #F87729  !important;} .receipt-head{background-color: #004165 !important;} .btn.btn-circle{float: right !important;} .btn-circle {cursor:pointer !important;width: 35px !important;height: 35px !important;text-align: center !important;padding: 6px 0 !important;line-height: 1.428571429 !important;border-radius: 50px !important;} .text-center {text-align: center !important ;} .my-3 {margin-top: 1rem !important ;margin-bottom: 1rem !important ;}.alert {padding: 0.75rem 1.25rem;margin-bottom: 1rem;border: 1px solid transparent;border-radius: 0.25rem;}.table {width: 100% !important;max-width: 100% !important;margin-bottom: 1rem !important; font-size: 13px;}table {border-collapse: collapse !important;background-color: transparent !important;} tr {display: table-row;vertical-align: inherit;border-color: inherit;}.table-bordered {border: 1px solid #eceeef !important;}.table tbody {font-weight: 300;letter-spacing: .4px;}.text-center {text-align: center !important;}.color-one {color: #004165 !important;} .mt-3 {margin-top: 1rem !important;}.m-0 {margin: 0 0 !important;}.table-bordered th, .table-bordered td {border: 1px solid #eceeef;}.table th, .table td {padding: 0.75rem;vertical-align: top;border-top: 1px solid #eceeef;} hr {margin-top: 0rem;margin-bottom: 0rem; h4{ font-size: 1.5rem !important;}}}</style>')
        mywindow.document.write(content);
        mywindow.document.write('</body></html>');

        //document.body.innerHTML = content;
        mywindow.document.close();
        mywindow.focus()
        mywindow.print();

        var miImg = (document.getElementById("img1")) ? document.getElementById("img1") : document.getElementById("img2");

        miImg["src"] = miImg["src"] + "?rnd=" + Math.random();

        mywindow.close();
        return true;

    }


    compartir() {
        $("#compartir").modal("show");
    }

    compartiendo = false;
    compartir_arv(data, email, arv) {
        this.compartiendo = true;
        var titulo = "ARV de la Cita - CODIGO_" + arv;
        if (email.trim()) {
            this.arv.compartir_avr(data, email, titulo, arv, this.tipo, this.estado)
                .subscribe(resp => {
                    $("#compartir").modal("hide");
                    this.sms.enviarAlerta({ mensaje: resp.mensaje, tipo: 1 })
                    this.compartiendo = false;
                })
        } else
            this.sms.enviarAlerta({ mensaje: "Debe ingresar un correo electrónico", tipo: 3 })
    }
} 


// WEBPACK FOOTER //
// C:/carlos/wks/web/vacios_web/src/app/modulo_compartido/arv/arv.component.ts